import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

const StyledBundesBanner = styled.a(
  () => css`
    display: inline-flex;
    img {
      display: block;
      width: 100%;
    }
  `,
);

const BundesBanner = ({ lang = 'de', ...rest }: BundesBannerProps) => {
  return (
    <StyledBundesBanner
      href={`https://www.bfe.admin.ch/bfe/${lang}/home.html`}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      <img
        src={`/images/bundesbanner_${lang}.svg`}
        alt={`bundesbanner ${lang}`}
        width={240}
        height={106}
        loading="lazy"
      />
    </StyledBundesBanner>
  );
};

export type BundesBannerProps = {
  /** Source of the BundesBanner */
  lang?: string;
};

export default BundesBanner;
